exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "button.btn-primary[data-v-7126a193],button.btn-primary[data-v-7126a193]:hover{color:#fff;background-color:#0060d6;font-weight:500}div.run-connection-modal button.btn.close.close-modal[data-v-7126a193]{top:-40px;position:relative}div.run-connection-modal legend.close-modal[data-v-7126a193]{max-height:25px}div.run-connection-modal .modal-footer[data-v-7126a193]{padding:0}div.run-connection-modal .modal-footer>*[data-v-7126a193]{margin:0}", ""]);

// exports
